import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const registerRequest = createAsyncThunk('/users/registerRequest', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.register(payload);
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
export const loginRequest = createAsyncThunk('users/loginRequest', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.login(payload);
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
export const logout = createAction('users/logout');
export const passwordReset = createAsyncThunk('users/passwordReset', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.passwordRecovery(payload);
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
export const clearBasket = createAction('users/clearBasket');

export const resetPasswordApi = createAsyncThunk('users/resetPasswordApi', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.resetPassword(payload);
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
